/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDtmDocCreateRequest } from '../types/PatchedDtmDocCreate';
import type { DtmDocCreateResponse } from '../types/DtmDocCreate';

export type DtmDocsSendToDmvsPartialUpdateRequest = PatchedDtmDocCreateRequest;
export type DtmDocsSendToDmvsPartialUpdateResponse = DtmDocCreateResponse;

export type DtmDocsSendToDmvsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dtm_docs/{id}/send_to_dmvs/
 *
 * ```yaml
 * operationId: dtm_docs_send_to_dmvs_partial_update
 * tags:
 *   - dtm_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmDocCreate'
 *     description: ''
 * ```
 */
export const dtmDocsSendToDmvsPartialUpdateOperation = ({
  id,
  ...rest
}: DtmDocsSendToDmvsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dtm_docs/${id}/send_to_dmvs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dtm_docs/{id}/send_to_dmvs/' };
  };

/**
 * PATCH /dmx-server/dtm_docs/{id}/send_to_dmvs/
 *
 * ```yaml
 * operationId: dtm_docs_send_to_dmvs_partial_update
 * tags:
 *   - dtm_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDtmDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmDocCreate'
 *     description: ''
 * ```
 */
export const dtmDocsSendToDmvsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DtmDocsSendToDmvsPartialUpdateQuery;
  request: PatchedDtmDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DtmDocCreateResponse>> => {
  const operation = dtmDocsSendToDmvsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
